export const tabMap = ["Basic", "Greek", "Roman", "Calculus", "Trigonometry"];
export const keyMap = [
    {
        tab: "Default",
        keys: [
            { label: "square exponent", charCode: "^{2}", mathCode: "^{2}" },
            { label: "nth exponent", charCode: "x^{ }", mathCode: "^{ }" },
            { label: "square root", mathCode: "\\sqrt{ }" },
            { label: "nth root", mathCode: "\\sqrt[]{}" },
            { label: "fraction", mathCode: "\\frac{ }{ }" },
            { label: "nth log", mathCode: "\\log _{ }\\left(\\right)" },
            { label: "pi", mathCode: "\\pi", useJax: 'true' },
            { label: "theta", mathCode: "\\theta", useJax: 'true' },
            { label: "infinity", mathCode: "\\infty", useJax: 'true' },
            { label: "integral", mathCode: "\\int", useJax: 'true' },
            { label: "derivative", mathCode: "\\frac{d}{dx}\\left(\\right)" },
            // { label: "exponential", mathCode: "e^{\\infty}", useJax: 'true' },
        ]
    },
    {
        tab: "Basic",
        keys: [
            { label: "greater than equals", mathCode: "\\ge", useJax: 'true' },
            { label: "lesser than equals", mathCode: "\\le", useJax: 'true' },
            { label: "dot", mathCode: "\\cdot", useJax: 'true' },
            { label: "division", mathCode: "\\div", useJax: 'true' },
            { label: "degree", mathCode: "^{\\circ}", useJax: 'true' },
            { label: "bracket", mathCode: "\\left(\\right)" },
            { label: "modulus bracket", mathCode: "\\left|\\right|" },
            { label: "f(x)", mathCode: "{f(x)}", useJax: 'true' },
            { label: "f o g", mathCode: "({f}\\circ{g})", useJax: 'true' },
            { label: "natural logarithm", mathCode: "\\ln \\left(\\right)" },
            { label: "exponential", mathCode: "e^{ }" },
            { label: "transpose bracket", mathCode: "\\left(\\right)^{'}" },
            { label: "partial derivative", mathCode: "\\frac{\\partial}{\\partial x}\\left(\\right)" },
            { label: "Integration", mathCode: "\\int_{}^{}" },
            { label: "limit", charCode: "\\lim", mathCode: "\\lim_{x\\to\\infty}\\left(\\right)" },
            { label: "summation", mathCode: "\\sum_{n=0}^{\\infty}" },
            { label: "sine", mathCode: "\\sin \\left(\\right)" },
            { label: "cosine", mathCode: "\\cos \\left(\\right)" },
            { label: "tangent", mathCode: "\\tan \\left(\\right)" },
            { label: "co-tangent", mathCode: "\\cot \\left(\\right)" },
            { label: "secent", mathCode: "\\sec \\left(\\right)" },
            { label: "co-secent", mathCode: "\\csc \\left(\\right)" },

        ]
    },
    {
        tab: "Roman",
        keys: [
            { label: "1", mathCode: "\\text{I}", useJax: 'true' },
            { label: "2", mathCode: "\\text{II}", useJax: 'true' },
            { label: "3", mathCode: "\\text{III}", useJax: 'true' },
            { label: "4", mathCode: "\\text{IV}", useJax: 'true' },
            { label: "5", mathCode: "\\text{V}", useJax: 'true' },
            { label: "6", mathCode: "\\text{VI}", useJax: 'true' },
            { label: "7", mathCode: "\\text{VII}", useJax: 'true' },
            { label: "8", mathCode: "\\text{VIII}", useJax: 'true' },
            { label: "9", mathCode: "\\text{IX}", useJax: 'true' },
            { label: "10", mathCode: "\\text{X}", useJax: 'true' },
            { label: "40", mathCode: "\\text{XL}", useJax: 'true' },
            { label: "50", mathCode: "\\text{L}", useJax: 'true' },
            { label: "90", mathCode: "\\text{XC}", useJax: 'true' },
            { label: "100", mathCode: "\\text{C}", useJax: 'true' },
            { label: "400", mathCode: "\\text{CD}", useJax: 'true' },
            { label: "500", mathCode: "\\text{D}", useJax: 'true' },
            { label: "900", mathCode: "\\text{CM}", useJax: 'true' },
            { label: "1000", mathCode: "\\text{M}", useJax: 'true' },
        ]
    },
    {
        tab: "Trigonometry",
        keys: [
            { label: "sine", mathCode: "\\sin \\left(\\right)", useJax: 'true' },
            { label: "cosine", mathCode: "\\cos \\left(\\right)", useJax: 'true' },
            { label: "tangent", mathCode: "\\tan \\left(\\right)", useJax: 'true' },
            { label: "co-tangent", mathCode: "\\cot \\left(\\right)", useJax: 'true' },
            { label: "secent", mathCode: "\\sec \\left(\\right)", useJax: 'true' },
            { label: "co-secent", mathCode: "\\csc \\left(\\right)", useJax: 'true' },
            { label: "arc sine", mathCode: "\\arcsin \\left(\\right)", useJax: 'true' },
            { label: "arc cosine", mathCode: "\\arccos \\left(\\right)", useJax: 'true' },
            { label: "arc tangent", mathCode: "\\arctan \\left(\\right)", useJax: 'true' },
            { label: "arc co-tangent", charCode: "{arccot()}", mathCode: "\\arccot \\left(\\right)" },
            { label: "arc secent", charCode: "{arcsec()}", mathCode: "\\arcsec \\left(\\right)" },
            { label: "arc co-secent", charCode: "{arccsc()}", mathCode: "\\arccsc \\left(\\right)" },
            { label: "sine", mathCode: "\\sinh \\left(\\right)", useJax: 'true' },
            { label: "cosine", mathCode: "\\cosh \\left(\\right)", useJax: 'true' },
            { label: "tangent", mathCode: "\\tanh \\left(\\right)", useJax: 'true' },
            { label: "co-tangent", mathCode: "\\coth \\left(\\right)", useJax: 'true' },
            { label: "secent", charCode: "{arccot()}", mathCode: "\\sech \\left(\\right)" },
            { label: "co-secent",charCode: "{csch()}",  mathCode: "\\csch \\left(\\right)" },
            { label: "arc sine", charCode: "{arcsinh()}", mathCode: "\\arcsinh \\left(\\right)" },
            { label: "arc cosine", charCode: "{arccosh()}", mathCode: "\\arccosh \\left(\\right)",},
            { label: "arc tangent", charCode: "{arctanh()}", mathCode: "\\arctanh \\left(\\right)" },
            { label: "arc co-tangent", charCode: "{arccoth()}", mathCode: "\\arccoth \\left(\\right)" },
            { label: "arc secent", charCode: "{arcsech()}", mathCode: "\\arcsech \\left(\\right)" },
            { label: "arc co-secent", charCode: "{arccsch()}", mathCode: "\\arccsch \\left(\\right)"},
        ]
    },
    {
        tab: "Calculus",
        keys: [
            { label: "derivative", mathCode: "\\f'" },
            { label: "derivative", mathCode: "\\frac{df}{dx}" },
            { label: "second derivative", mathCode: "\\frac{d^2}{dx^2}\\left(\\right)" },
            { label: "nth derivative", mathCode: "\\frac{d^{ }}{dx^{ }}\\left(\\right)" },
            { label: "partial derivative", mathCode: "\\frac{\\partial f}{\\partial x}" },
            { label: "nth partial derivative", mathCode: "\\frac{\\partial ^{ }}{\\partial x^{ }}\\left(\\right)" },
            { label: "integral", mathCode: "\\int" },
            { label: "double integral", mathCode: "\\int\\int" },
            { label: "triple integral", mathCode: "\\int\\int\\int" },
            { label: "limits", charCode: "\\lim", mathCode: "\\lim _{x\\to }\\left(\\right)" },
            { label: "limit x -> ∞", mathCode: "\\lim_{x\\to \\infty}", useJax: 'true' },
            { label: "limit x -> 0+", mathCode: "\\lim_{x\\to 0+}", useJax: 'true' },
            { label: "limit x -> 0-", mathCode: "\\lim_{x\\to 0-}", useJax: 'true' },
            { label: "transpose bracket", mathCode: "\\left(\\right)^'" },
            { label: "double transpose bracket", mathCode: "\\left(\\right)^{''}" },
            { label: "summation", mathCode: "\\sum_{}^{}\\left(\\right)" },
            { label: "summation", mathCode: "\\sum_{n=1}^{\\infty}a_n", useJax: 'true' },
            { label: "product", mathCode: "\\prod_{}^{}\\left(\\right)" },
            { label: "product", mathCode: "\\prod_{n=1}^{\\infty}a_n", useJax: 'true' },
        ]
    },
    {
        tab: "Greek",
        keys: [
            { label: "alpha", mathCode: "\\alpha", useJax: 'true' },
            { label: "beta", mathCode: "\\beta", useJax: 'true' },
            { label: "gamma", mathCode: "\\gamma", useJax: 'true' },
            { label: "delta", mathCode: "\\delta", useJax: 'true' },
            { label: "epsilon, varepsilon", charCode: "𝜀", mathCode: "\\varepsilon", useJax: 'true' },
            { label: "epsilon lunate", charCode: "𝜖", mathCode: "\\epsilon", useJax: 'true' },
            { label: "zeta", charCode: "𝜁", mathCode: "\\zeta", useJax: 'true' },
            { label: "eta", charCode: "𝜂", mathCode: "\\eta", useJax: 'true' },
            // { label: "curly theta, vartheta", charCode: "𝜗", mathCode: "\\vartheta" }, 
            { label: "theta", charCode: "𝜃", mathCode: "\\theta", useJax: 'true' },
            { label: "iota", charCode: "𝜄", mathCode: "\\iota", useJax: 'true' },
            { label: "kappa", charCode: "𝜅", mathCode: "\\kappa", useJax: 'true' },
            { label: "lambda", charCode: "𝜆", mathCode: "\\lambda", useJax: 'true' },
            { label: "mu", charCode: "𝜇", mathCode: "\\mu", useJax: 'true' },
            { label: "nu", charCode: "𝜈", mathCode: "\\nu", useJax: 'true' },
            { label: "xi", charCode: "𝜉", mathCode: "\\xi", useJax: 'true' },
            { label: "pi", charCode: "𝜋", mathCode: "\\pi", useJax: 'true' },
            // { label: "rho, varrho", charCode: "𝜚", mathCode: "\\varrho" }, 
            { label: "rho", charCode: "𝜌", mathCode: "\\rho", useJax: 'true' },
            { label: "sigma", charCode: "𝜎", mathCode: "\\sigma", useJax: 'true' },
            // { label: "final sigma, varsigma", charCode: "𝜍", mathCode: "\\varsigma" }, 
            { label: "tau", charCode: "𝜏", mathCode: "\\tau", useJax: 'true' },
            { label: "upsilon", charCode: "𝜐", mathCode: "\\upsilon", useJax: 'true' },
            { label: "phi", charCode: "𝜙", mathCode: "\\phi", useJax: 'true' },
            { label: "phi, varphi", charCode: "𝜑", mathCode: "\\varphi", useJax: 'true' },
            { label: "chi", charCode: "𝜒", mathCode: "\\chi", useJax: 'true' },
            { label: "psi", charCode: "𝜓", mathCode: "\\psi", useJax: 'true' },
            { label: "omega", charCode: "𝜔", mathCode: "\\omega", useJax: 'true' },
            //     ]
            // },
            // {
            //     tab: "ABΓ",
            //     keys: [
            // { label: "alpha", mathCode: 'A' },
            // { label: "beta", mathCode: "B" },
            { label: "gamma", mathCode: "\\Gamma", useJax: 'true' },
            { label: "delta", mathCode: "\\Delta", useJax: 'true' },
            // { label: "epsilon, varepsilon", charCode: "𝜀", mathCode: "\\varepsilon" }, 
            // { label: "epsilon", mathCode: "E" },
            // { label: "zeta", mathCode: "Z" },
            // { label: "eta", mathCode: "H" },
            // { label: "curly theta, vartheta", charCode: "𝜗", mathCode: "\\vartheta" }, 
            { label: "theta", mathCode: "\\Theta", useJax: 'true' },
            // { label: "iota", mathCode: "I" },
            // { label: "kappa", mathCode: "K" },
            { label: "lambda", mathCode: "\\Lambda", useJax: 'true' },
            // { label: "mu", mathCode: "M" },
            // { label: "nu", mathCode: "N" },
            { label: "xi", mathCode: "\\Xi", useJax: 'true' },
            { label: "pi", mathCode: "\\Pi", useJax: 'true' },
            // { label: "rho, varrho", charCode: "𝜚", mathCode: "\\varrho" }, 
            // { label: "rho", mathCode: "P" },
            { label: "sigma", mathCode: "\\Sigma", useJax: 'true' },
            // { label: "final sigma, varsigma", charCode: "𝜍", mathCode: "\\varsigma" }, 
            // { label: "tau", mathCode: "T" },
            // { label: "upsilon", mathCode: "Y" },
            { label: "phi", mathCode: "\\Phi", useJax: 'true' },
            // { label: "phi, varphi", charCode: "𝜑", mathCode: "\\varphi" },
            // { label: "chi", mathCode: "X" },
            { label: "psi", mathCode: "\\Psi", useJax: 'true' },
            { label: "omega", mathCode: "\\Omega", useJax: 'true' },
            { label: "aleph", mathCode: "\\aleph", useJax: 'true' },
            { label: "sigma", mathCode: "\\Sigma", useJax: 'true' },
        ]
    }
]
export const labels = "delta omega chi epsilon gamma beta alpha tangent degree exponent infinity pi theta sqrt sum sigma integral product summation psi omega aleph phi xi"

// export const labels = " delta omega chi epsilon gamma beta  alpha tangent limit arc tangent degree exponent infinity  pi theta sqrt sum sigma integral derivative product summation psi omega aleph phi xi lamda"